import { render, staticRenderFns } from "./cartAndOrder_price.vue?vue&type=template&id=a4260a62&scoped=true"
import script from "./cartAndOrder_price.vue?vue&type=script&lang=js"
export * from "./cartAndOrder_price.vue?vue&type=script&lang=js"
import style0 from "./cartAndOrder_price.vue?vue&type=style&index=0&id=a4260a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4260a62",
  null
  
)

export default component.exports